// import

import {styled} from 'goober';
import {useForm} from 'react-hook-form';

import {SignupForm} from 'modules/SignupForm';
import {Type} from 'modules/Type';

// types

type Props = {
  blurb?: string;
  buttonText: string;
  placeholder?: string;
  title: string;
};

// component

export function SignupWidget(props: Props) {
  const {title, blurb = '', buttonText, placeholder, ...rest} = props;
  const form = useForm();

  return (
    <Div {...rest} data-test="side-signup">
      <h1 className="cta">{title}</h1>

      <Type>
        <div className="blurb" dangerouslySetInnerHTML={{__html: blurb}} />

        <SignupForm
          buttonClass="button teal"
          buttonText={buttonText}
          className="form"
          form={form}
        />
      </Type>
    </Div>
  );
}

// styles

const Div = styled('div')`
  .cta {
    font-family: var(--font-head);
    font-size: 2rem;
    line-height: 2.5rem;
    letter-spacing: 0;
    font-weight: 500;
    margin: 0 0 0.5rem;
  }

  .blurb {
    font-size: 1.125rem;
    line-height: 1.5rem;
    margin-bottom: 0.75rem;
  }

  & .error {
    color: var(--red-30);
  }

  & .success {
    color: var(--blue);
  }

  .button {
    width: 100%;
  }
`;
